export const environment = {
  cdnUrl: 'https://raw.githubusercontent.com/gilles-gardet/gilles-gardet.github.io/main',
};
